module.exports = __webpack_public_path__ + "img/Druid.04ea228c.png";